import { render, staticRenderFns } from "./CaretDownIcon.vue?vue&type=template&id=c4b077b0&scoped=true&"
var script = {}
import style0 from "./CaretDownIcon.vue?vue&type=style&index=0&id=c4b077b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b077b0",
  null
  
)

export default component.exports